import e from"./_baseIsArguments.js";import r from"./isObjectLike.js";var t=e,o=r,a=Object.prototype,l=a.hasOwnProperty,n=a.propertyIsEnumerable,s=t(function(){return arguments}())?t:function(e){return o(e)&&l.call(e,"callee")&&!n.call(e,"callee")};export{s as default};
//# sourceMappingURL=isArguments.js.map
